import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { CartSettingForDeliveryWrap } from './index.styled'
import DeliveryProductQuantitySettings from './productQuantity'
import DeliveryBeeperSettings from './beeper'
import DeliveryChangeSettings from './change'
import { DELIVERY_MODULE } from '../constants'
import { getDeliverySettingsBeeperConfigsThunk, getDeliverySettingsCartSettingsThunk, getDeliverySettingsChangeSettingsThunk } from '../../../redux/thunk/deliverySettings'

const CartSettingForDelivery = React.memo(() => {
	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getDeliverySettingsCartSettingsThunk(DELIVERY_MODULE))
		dispatch(getDeliverySettingsChangeSettingsThunk(DELIVERY_MODULE))
		dispatch(getDeliverySettingsBeeperConfigsThunk(DELIVERY_MODULE))
	}, [dispatch])

	return (
		<CartSettingForDeliveryWrap>
			<DeliveryBeeperSettings />
			<DeliveryProductQuantitySettings />
			<DeliveryChangeSettings />
		</CartSettingForDeliveryWrap>
)
})

CartSettingForDelivery.displayName = 'CartSettingForDelivery'
export default CartSettingForDelivery
